import CloseSvg from '@/assets/assetfi/Close';
import { Drawer, Box, IconButton, Typography, useTheme } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import packageJson from '../../../package.json';

export default function DrawerSideBar({
  mobileOpen,
  handleDrawerToggle,
}: {
  mobileOpen: boolean;
  handleDrawerToggle: () => void;
}) {
  const version = packageJson.version;
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <Drawer
      variant="temporary"
      open={mobileOpen}
      onClose={handleDrawerToggle}
      ModalProps={{ keepMounted: true }}
      sx={{
        display: { xs: 'block', md: 'none' },
        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: '100%' },
      }}
    >
      <Box
        sx={{
          padding: '16px',
          borderBottom: '0.5px solid #D9D9D9',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <IconButton aria-label="close drawer" edge="start" onClick={handleDrawerToggle}>
          <CloseSvg width={24} height={24} />
        </IconButton>
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: '10px',
          flexDirection: 'column',
          padding: '32px 16px',
        }}
      >
        <Typography
          sx={{
            color: location.pathname.startsWith('/pools') ? theme.background.blue : theme.greyscale.darkgrey2,
            cursor: 'pointer',
            fontWeight: '600',
            fontSize: '32px',
            lineHeight: '42px',
            letterSpacing: '-0.02em',
          }}
          color={theme.greyscale.darkgrey2}
          onClick={() => {
            navigate('/pools');
            handleDrawerToggle();
          }}
        >
          Pools
        </Typography>
        <Typography
          sx={{
            color: location.pathname.startsWith('/portfolio') ? theme.background.blue : theme.greyscale.darkgrey2,
            cursor: 'pointer',
            fontWeight: '600',
            fontSize: '32px',
            lineHeight: '42px',
            letterSpacing: '-0.02em',
          }}
          color={theme.greyscale.darkgrey2}
          onClick={() => {
            navigate('/portfolio');
            handleDrawerToggle();
          }}
        >
          Portfolio
        </Typography>

        <Typography
          sx={{
            color: theme.greyscale.darkgrey2,
            cursor: 'pointer',
            fontWeight: '600',
            fontSize: '32px',
            lineHeight: '42px',
            letterSpacing: '-0.02em',
          }}
          color={theme.greyscale.darkgrey2}
          onClick={() => {
            const tokensUrl = 'https://tokens.ecpay.io';
            window.open(tokensUrl, '_blank', 'noopener,noreferrer');
            handleDrawerToggle();
          }}
        >
          Tokens
        </Typography>
      </Box>
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          right: 0,
          margin: 2, // Optional: adds some margin from the bottom and right edge
        }}
      >
        <Typography variant="body1">version: {version}</Typography>
      </Box>
    </Drawer>
  );
}
